/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import {
    BedroomParentOutlined, ChildCare,
    PersonOutline,
    NightsStayOutlined, PersonAdd,
    PointOfSaleOutlined, PriceChangeOutlined,
    SellOutlined
} from "@mui/icons-material";
import IngresoDinero from "../../../Modulo_formularios/Componentes/IngresoDinero";
import IngresoSelect from "../../../Modulo_formularios/Componentes/IngresoSelect";
import {TIPOCLIENTE} from "../../../Constantes";

const Formulario_Reserva_Valores = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography sx={{fontSize: 14}}>Valores Servicio</Typography>
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoTexto Icono={BedroomParentOutlined} nombre={'# Habitacion'} dato={'numero'}
                                  editable={false} {...props} />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoTexto Icono={NightsStayOutlined} nombre={'Num Noches'} dato={'numNoches'}
                                  editable={false} {...props} />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoTexto Icono={PersonOutline} nombre={'num Adultos'} dato={'numAcompanantes'}
                                  editable={false} {...props} />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoDinero Icono={PriceChangeOutlined} nombre={'Valor Adultos'} dato={'valorAdultos'} {...props}
                                   editable={false}
                    />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoTexto Icono={ChildCare} nombre={'Num Niños'} dato={'numNinos'} {...props}
                                  editable={false}
                    />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoDinero Icono={PriceChangeOutlined} nombre={'Valor Niños'} dato={'valorNinos'} {...props}
                                   editable={false}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoDinero Icono={PointOfSaleOutlined} nombre={'Valor Habitacion'} dato={'valor'} {...props}
                                   editable={false}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography sx={{fontSize: 14}}>Notas Internas</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto nombre={'Notas Internas'} dato={'notas'} {...props}
                                  lineas={6}

                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Reserva_Valores